import { v4 as uuidv4 } from 'uuid';
import { MuiIcons } from 'v2/resources/types/icon';
import { IGradientIconProps } from './types';

const GradientIcon: React.FC<IGradientIconProps> = ({
  iconName,
  id = `gradient-${uuidv4()}`,
  rotate = 45,
  colors,
  size,
  ...rest
}) => {
  const Component = MuiIcons[iconName];

  return (
    <>
      <svg width={0} height={0}>
        <linearGradient
          id={id}
          x1={1}
          y1={0}
          x2={1}
          y2={1}
          gradientTransform={`rotate(${rotate}) `}
        >
          {colors.map((color, index) => (
            <stop
              key={index}
              offset={`${(index / (colors.length - 1)) * 100}%`}
              stopColor={color}
            />
          ))}
        </linearGradient>
      </svg>
      <Component {...rest} sx={{ fontSize: size, fill: `url(#${id})` }} />
    </>
  );
};

export default GradientIcon;
